// Farben des PIPR-Charts.
//
// Blau/Grau/Rot statt Grün/Rot: kein Ampel-Beiklang, und für Rot-Grün-Schwäche
// lesbar. Die PIPR-Linie ist das einzige Element in voller Helligkeit.

export const PALETTE = {
    bg: "#202124",
    card: "#1b1b1c",
    ink: "#f5f5f5",
    inkMuted: "rgba(245, 245, 245, 0.62)",
    inkFaint: "rgba(245, 245, 245, 0.38)",
    grid: "rgba(245, 245, 245, 0.12)",
    gridStrong: "rgba(245, 245, 245, 0.22)",
    forwardWash: "rgba(245, 245, 245, 0.035)",
    pendingBand: "rgba(245, 245, 245, 0.11)",

    cutLarge: "#2a78d6",
    cut: "#5aa0e0",
    hold: "#8a8a8a",
    hike: "#e34948",
    hikeLarge: "#c93a39",
};

/** Farbe eines Bins nach Richtung und Größe der Änderung. */
export function binColor(deltaBp: number): string {
    if (deltaBp <= -50) return PALETTE.cutLarge;
    if (deltaBp < 0) return PALETTE.cut;
    if (deltaBp === 0) return PALETTE.hold;
    if (deltaBp >= 50) return PALETTE.hikeLarge;
    return PALETTE.hike;
}

/**
 * Deckkraft einer Zelle aus ihrer Wahrscheinlichkeit. Wurzelartige Kennlinie,
 * damit kleine Wahrscheinlichkeiten noch sichtbar sind.
 */
export function binOpacity(pPerMille: number): number {
    return 0.07 + 0.82 * Math.pow(pPerMille / 1000, 0.72);
}

/**
 * Farbe für eine gerichtete Änderung, unabhängig von der Bin-Rasterung.
 * Für Kennzahlen im Kopf, wo auch krumme Werte wie −18 bp vorkommen.
 */
export function directionColor(deltaBp: number): string {
    if (deltaBp <= -1) return PALETTE.cutLarge;
    if (deltaBp >= 1) return PALETTE.hike;
    return PALETTE.hold;
}